/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
//     http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import thunk from "redux-thunk";
import { reducers } from "../reducer";
import { createStore, applyMiddleware, compose } from "redux";
import logger from "redux-logger";
import AppConfig from "../../config/AppConfig";

const middlewares = [thunk];

if (AppConfig.dev_mode === true && typeof window !== "undefined") {
  middlewares.push(logger);
}

export const initialStore = (initialState = {}, history) => {
  return createStore(
    reducers,
    initialState,
    compose(applyMiddleware(...middlewares))
  );
};
